import { connect } from 'react-redux';
import OutlineSection from './outlineSection';
import navigateToSection from '../../../shared/actions/outlineUtils';

const mapDispatchToProps = dispatch => ({
  onClick: dest => dispatch(navigateToSection(dest)),
});

export default connect(() => ({}), mapDispatchToProps)(OutlineSection);
